import React from 'react';
import { useSelector } from 'react-redux';
import MetaTags from 'components/common/MetaTags';
import PageHeader from 'components/NewDesign/PageHeader';
import MainContent from 'components/NewDesign/MainContent';
import ResultsSync from 'components/admin/reports/ResultsSync';

const ResultsSyncPage = () => {
  const { selectedClub } = useSelector((state) => state.user || {});

  return (
    <>
      <MetaTags title="SplitFast | Results Sync Report" />
      <MainContent>
        <PageHeader title="Results Sync Report" />

        {!selectedClub ? (
          <div style={{ minHeight: '100vh' }} />
        ) : (
          <ResultsSync clubID={selectedClub?.clubID} />
        )}
      </MainContent>
    </>
  );
};

export default ResultsSyncPage;
